/* eslint-disable @reatom/unit-naming-rule */

import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type { TypeHelper } from '@blade/std-lib'
import type {
  ServicesPoolGetByCreatorCreatePayload,
  ServicesPoolGetByCreatorOverviewCreatePayload,
} from '@blade/trade-api-client'

export const fetchPairsByCreatorAction = action(
  async (
    ctx,
    {
      network,
      ...req
    }: TypeHelper.OverrideKeys<
      ServicesPoolGetByCreatorCreatePayload,
      {
        network: Network.Network
      }
    >,
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.services.servicesPoolGetByCreatorCreate, [
        {
          ...req,
          network: Network.toDto(network),
        },
      ]),
    )

    return result.pipe(Result.mapError(ApiError.fallbackToUnknown))
  },
)

export const fetchPairsOverviewByCreatorAction = action(
  async (
    ctx,
    {
      network,
      ...req
    }: TypeHelper.OverrideKeys<
      ServicesPoolGetByCreatorOverviewCreatePayload,
      {
        network: Network.Network
      }
    >,
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(
        ctx,
        tradeApiClient.services.servicesPoolGetByCreatorOverviewCreate,
        [
          {
            ...req,
            network: Network.toDto(network),
          },
        ],
      ),
    )

    return result.pipe(Result.mapError(ApiError.fallbackToUnknown))
  },
)
